export const common = {
  // Header Navigation
  nav: {
    home: 'ANA SAYFA',
    brandStory: 'MARKA HİKAYESİ',
    whoWeServe: 'KİMLERE HİZMET VERİYORUZ',
    products: 'ÜRÜNLER',
    privateLabel: 'ÖZEL MARKA',
    shop: 'MAĞAZA',
    contact: 'İLETİŞİM',
  },

  // Product Categories
  productCategories: {
    roastedCoffee: 'Kavrulmuş Kahve',
    pods: 'Pod Kahve',
    compatibleCapsules: 'Uyumlu Kapsüller',
    milkshakes: 'Milkshake',
    horeca: 'HoReCa',
    tea: 'Çay',
    machines: 'Kahve & Çay Makineleri',
  },

  // Common Actions
  actions: {
    seeDetails: 'Detayları Gör',
    learnMore: 'Daha Fazla Bilgi',
    contactUs: 'Bize Ulaşın',
    viewAll: 'Tümünü Gör',
  },

  // Footer
  footer: {
    tagline: 'Vizyonun forma dönüştüğü yer',
    description: 'Mükemmellik için tasarlanmış premium kahve ve HoReCa çözümleri. İtalyan mirasına dayalı, global misafirperverlik için mühendisliği yapılmış.',
    address: 'ADRES',
    email: 'E-POSTA',
    copyright: '© 2026 LUCENDO. Tüm hakları saklıdır.',
    privacyPolicy: 'Gizlilik Politikası',
    terms: 'Şartlar',
    poweredBy: 'Akıllı Mum tarafından desteklenmektedir',
  },
};